import { combineReducers } from "redux";
import usersReducer from "./userReducer";
import typesReducer from "./typeReducer";

const rootReducer = combineReducers({ user: usersReducer, type: typesReducer })

export default rootReducer